import React from 'react';
import { HoInvitedBetterWayToBuildContainer } from '../../common';
import DesktopSlider from './desktop-slider';
import MobileSlider from './MobileSlider';

interface Props {
  header: string;
  description: string;
}

const BetterWayToBuild: React.FC<Props> = ({ header, description }) => (
  <HoInvitedBetterWayToBuildContainer
    numberOfSlides={6}
    header={header}
    description={description}
    screenReaderText="Carousel with 6 slides shown at a time.Use the Previous and Next buttons
      to navigate, or the slide buttons to jump to the slides."
  >
    <DesktopSlider />
    <MobileSlider />
  </HoInvitedBetterWayToBuildContainer>
);

export default BetterWayToBuild;
